// Messages for API validation errors sent as { code, values }, see components/notifications/Alerts
export const errorMessages = {
  previousBedAssigned:
    'This census entry cannot be deleted. Deleting it would move the resident back to {{facility}}, suite {{suite}}, bed {{bed}}, which is now assigned to another resident. Free up the bed first, then try again.',
  censusFieldsLocked: 'Census {{fields}} cannot be changed by an edit'
}
